export const API_ROOT: string = import.meta.env.VITE_API_ROOT;
export const APP_ENV: string = import.meta.env.VITE_APP_ENV;
